export default "__VITE_ASSET__46fb2b8f__"